import { useCallback, useEffect, useRef, useState } from 'react';
import { getSelectedBlockNode } from 'libs/common/utils';
import { getNodeOffsetTop } from '../util/block';

/**
 * Handle the visibility of the `ToggleBlockToolbar` given the state of the editor
 */
var useToggleBlockToolbar = function useToggleBlockToolbar(editorState) {
  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(false),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var _useState3 = useState({
    top: 0
  }),
      buttonPosition = _useState3[0],
      setButtonPosition = _useState3[1];

  var _useState4 = useState(),
      block = _useState4[0],
      setBlock = _useState4[1];

  var currentSelectedNode = useRef(null);
  var blockKey = useRef(null);
  var hideToolbar = useCallback(function () {
    setIsOpen(false);
    setIsVisible(false);
  }, []);
  var findCurrentBlockNode = useCallback(function (currentBlock, blockMap) {
    var selectedNode = getSelectedBlockNode(currentBlock, blockMap);

    if (!selectedNode) {
      hideToolbar();
      return;
    }

    currentSelectedNode.current = selectedNode;
    var offsetTop = getNodeOffsetTop(editorState, currentBlock, selectedNode);
    setIsVisible(true);
    setButtonPosition({
      top: offsetTop
    });
  }, [hideToolbar, editorState]);
  var toggleToolbar = useCallback(function () {
    return setIsOpen(function (currentIsOpen) {
      return !currentIsOpen;
    });
  }, []);
  useEffect(function () {
    var contentState = editorState.getCurrentContent();
    var blockMap = contentState.getBlockMap();
    var selectionState = editorState.getSelection();
    var selectedBlock = contentState.getBlockForKey(selectionState.getAnchorKey());
    var selectedBlockKey = selectedBlock.getKey();
    var isSelectionNotEmpty = !selectionState.isCollapsed() || selectionState.getAnchorKey() !== selectionState.getFocusKey();
    var isBlockNotEmpty = selectedBlock.getLength() > 0;
    setBlock(selectedBlock);

    switch (true) {
      case isSelectionNotEmpty:
      case isBlockNotEmpty:
        {
          hideToolbar();
          break;
        }

      default:
        {
          blockKey.current = selectedBlockKey;
        }
    }

    if (selectedBlock.getLength() === 0) {
      findCurrentBlockNode(selectedBlock, blockMap);
      setIsVisible(true);
    }
  }, [editorState, findCurrentBlockNode, hideToolbar, blockKey, setIsVisible]);
  return {
    block: block,
    isOpen: isOpen,
    isVisible: isVisible,
    buttonPosition: buttonPosition,
    toggleToolbar: toggleToolbar
  };
};

export default useToggleBlockToolbar;